/**
 * Main Entry Point - Rising Sun Spatial Canvas
 * Renders the app with identity provider and spatial canvas
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppWithIdentity } from './components/app-with-identity';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <AppWithIdentity />
  </React.StrictMode>
);
